<div class="main">
    <div class="dx-field-title" translate>localAgentsMaintenances.pageTitle</div>
    <div class="dx-field selector">
        <div class="dx-field-label">{{ this.currentEnvironmentName }}&nbsp;/</div>
        <div class="dx-field-value">
            <dx-select-box #agentPicker [dataSource]="localAgents" displayExpr="name" valueExpr="id" (selectedItemChange)="filterChanged($event)"
                           [noDataText]="'_pickers.nodata' | translate" [placeholder]="'_pickers.placeholder' | translate">
            </dx-select-box>
        </div>
    </div>
    <br />
    <dx-data-grid #maintenances 
                  [dataSource]="dataSource" 
                  keyExpr="id" 
                  [columnAutoWidth]="true" 
                  [wordWrapEnabled]="true"
                  height="calc(100vh - 210px)" 
                  hoverStateEnabled="true"
                  [errorRowEnabled]="false">
        <dxo-search-panel [visible]="true" [width]="250" [placeholder]="'_commons.search' | translate"></dxo-search-panel>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-paging [enabled]="false"></dxo-paging>
        <dxo-summary>
            <dxi-total-item column="description" [displayFormat]="'localAgentsMaintenances.lblMaintenancesCount' | translate" summaryType="count"></dxi-total-item>
        </dxo-summary>
        <dxo-toolbar>
            <dxi-item location="after">
                <div *dxTemplate>
                    <dx-button icon="add" [text]="'_commons.add' | translate" (onClick)="displayNewPopup()"></dx-button>
                </div>
            </dxi-item>
            <dxi-item location="after">
                <div *dxTemplate>
                    <dx-button icon="refresh" [text]="'_commons.refresh' | translate" (onClick)="loadDataSource()"></dx-button>
                </div>
            </dxi-item>
            <dxi-item name="searchPanel"></dxi-item>
        </dxo-toolbar>

        <dxi-column dataField="description" [caption]="'localAgentsMaintenances.lblDescription' | translate"></dxi-column>
        <dxi-column dataField="startOn" [caption]="'localAgentsMaintenances.lblStartOn' | translate"
                    [calculateCellValue]="displayDateStartOn"></dxi-column>
        <dxi-column dataField="endOn" [caption]="'localAgentsMaintenances.lblEndOn' | translate" [calculateCellValue]="displayDateEndOn"></dxi-column>
        <dxi-column [width]="180" cellTemplate='actionsCellTemplate'></dxi-column>
        <div *dxTemplate="let cell of 'actionsCellTemplate'">
            <dx-button class="edit" icon="edit" [hint]="'_commons.edit' | translate" (onClick)="displayEditPopup(cell.data)"></dx-button>
            <dx-button class="delete" icon="trash" [hint]="'_commons.delete' | translate" (onClick)="deleteMaintenance(cell.data.id)"></dx-button>
        </div>
    </dx-data-grid>
</div>

<!-- New & Edit popup -->
<dx-popup [title]="'localAgentsMaintenances.popupTitle' | translate" [height]="350" [(visible)]="isPopupVisible">
    <div *dxTemplate="let data of 'content'">
        <dx-scroll-view direction="vertical" *ngIf="isPopupVisible">
            <dx-validation-group #maintenanceValidation>
                <div class="dx-field">
                    <div class="dx-field-label" translate>localAgentsMaintenances.lblDescription<span class="dx-field-item-required-mark">
                            *</span></div>
                    <div class="dx-field-value">
                        <dx-text-box [(value)]="selectedMaintenance.description">
                            <dx-validator>
                                <dxi-validation-rule type="required" [message]="'localAgentsMaintenances.msgDescriptionRequired' | translate"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>localAgentsMaintenances.lblStartOn</div>
                    <div class="dx-field-value">
                        <dx-date-box [(value)]="selectedMaintenance.startOn" type="datetime" pickerType="calendar"
                            [showAnalogClock]="false">
                        </dx-date-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>localAgentsMaintenances.lblEndOn</div>
                    <div class="dx-field-value">
                        <dx-date-box [(value)]="selectedMaintenance.endOn" type="datetime" pickerType="calendar"
                            [showAnalogClock]="false">
                        </dx-date-box>
                    </div>
                </div>
            </dx-validation-group>
            <div class="flex bottom-buttons">
                <dx-button class="add" [text]="'_commons.add' | translate" (onClick)="createMaintenance()"
                    [visible]="isNew"></dx-button>
                <dx-button class="save" [text]="'_commons.save' | translate" (onClick)="updateMaintenance()"
                    [visible]="!isNew"></dx-button>
                <dx-button class="cancel" [text]="'_commons.cancel' | translate" (onClick)="this.isPopupVisible = false"></dx-button>
            </div>
        </dx-scroll-view>
    </div>
</dx-popup>

<!-- Loading panel -->
<dx-load-panel [visible]="isLoadPanelVisible" [message]="'_commons.loading' | translate" [position]="{ of: '.app-content', boundary: '.app-content' }"></dx-load-panel>
